var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../../hooks/useConfig";
import { RequestPastStatementButton, RequestPastStatementsContainer, RequestPastStatementsImage, RequestPastStatementsTextContainer, RequestPastStatementsWrapper, } from "./subcomponents";
import { IMAGE_ASSETS } from "../../../const/assets";
export var RequestPastStatements = function (_a) {
    var accountId = _a.accountId, handleRequestPastStatementsClick = _a.handleRequestPastStatementsClick;
    var assets = useConfig().hosts.assets;
    var t = useTranslation().t;
    if (!accountId || !handleRequestPastStatementsClick)
        return null;
    return (_jsx(RequestPastStatementsWrapper, { children: _jsxs(RequestPastStatementsContainer, { children: [_jsx(RequestPastStatementsImage, { src: "".concat(assets).concat(IMAGE_ASSETS.REQUEST_PAST_STATEMENTS_ICON), alt: "" }), _jsxs(RequestPastStatementsTextContainer, { children: [_jsx("span", { children: t("modal.requestPastStatements.prefix") }), _jsx(RequestPastStatementButton, __assign({ buttonType: "text", onClick: function () { return handleRequestPastStatementsClick(accountId); }, "data-object": "statements", "data-reason": "request past statements", "data-type": "link", "data-analytics": "clicktrackingevent" }, { children: t("modal.requestPastStatements.link") })), _jsx("span", { children: t("modal.requestPastStatements.suffix") })] })] }) }));
};
